import axios from 'axios'

const state = {
    myReviews: null,
    reviewTrans: null,
}

const getters = {
    myReviews (state) {
        return state.myReviews
    },
    reviewTrans (state) {
        return state.reviewTrans
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    async fetchMyReviews({ commit }, userObj) {
        let response = null
        // only use token if the person is looking up other users without signing in
        if(userObj.token){
            response = await axios.post(`/reviews/fetchReviews`, userObj, {
                headers: {
                    'Authorization': `Bearer ${userObj.token}`
                }
            })
        } else {
            response = await axios.post(`/reviews/fetchReviews`, userObj)
        }
        if(!response.data.error){
            commit('SET_REVIEWS', response.data.result.reviewers)
        }
    },

    async addReview({ dispatch, commit, getters }, reviewObj) {
        let response = await axios.post(`/reviews/review`, reviewObj)
        if(!response.data.error){
            let lookupUserObj = { userId: getters.lookupUser._id }
            dispatch('fetchMyReviews', lookupUserObj)
            commit('REVIEW_TRANSACTION', null)
        }
    },
    
    async removeReview({ dispatch, getters }, reviewObj) {
        let response = await axios.post(`/reviews/unreview`, reviewObj)
        if(!response.data.error){
            let lookupUserObj = { userId: getters.lookupUser._id }
            dispatch('fetchMyReviews', lookupUserObj)
        }
    },
    
    async reviewTransaction({ commit }, reviewObj) {
        commit('REVIEW_TRANSACTION', reviewObj)
    },

}

const mutations = {
    SET_REVIEWS: (state, myReviews) => (state.myReviews = myReviews),
    REVIEW_TRANSACTION: (state, reviewTrans) => (state.reviewTrans = reviewTrans),
}

export default {
    state,
    getters,
    actions,
    mutations
}